import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getOrderMSTeamMemberListData } from './mockData'
import type { THrid } from '~/types/models'
import type { IOrderMSTeamMember } from '~/types/order/models'

interface GetOrderMSTeamMembersResponse {
  data: IOrderMSTeamMember[] | undefined
}

// post

const postOrderMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOrderMSTeamMemberListData)
}

const patchOrderMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOrderMSTeamMemberListData)
}

const deleteOrderMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOrderMSTeamMemberListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/ordermsteammembers',
    handler: postOrderMSTeamMember,
  },
  {
    method: 'patch',
    path: '/api/ordermsteammembers/:id',
    handler: patchOrderMSTeamMember,
  },
  {
    method: 'delete',
    path: '/api/ordermsteammembers/:id',
    handler: deleteOrderMSTeamMember,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
